import React from "react";
import VendorMaterialsWorkspace from "../../components/VendorMaterialsWorkspace";
import PageHeader from "../../components/PageHeader";
import { useTerminology } from "../../context/TerminologyContext";

export default function VendorMaterialsPage() {
  const { t, tp } = useTerminology();
  return (
    <div className="page-stack">
      <PageHeader
        eyebrow="Super Admin"
        icon="vendors"
        title={`${t("vendor")} & ${tp("material")}`}
        subtitle={`Contained ${t("vendor").toLowerCase()} setup, ${t("material").toLowerCase()} onboarding, and checklist thresholds aligned with the premium shell.`}
      />
      <VendorMaterialsWorkspace scopeLabel="Super Admin" />
    </div>
  );
}
